import { FormHelperText } from "@mui/material";

export function FieldSpacer() {
  return <FormHelperText aria-hidden> </FormHelperText>;
}
